import React from "react";

const Badge = ({
  children,
  variant,
  className = "",
}: {
  children: React.ReactNode;
  variant?: "outline" | "solid";
  className?: string;
}) => {
  return (
    <div
      className={`inline-block text-xs  mr-2 px-2.5 py-0.5 rounded-lg ${
        variant === "outline"
          ? "bg-transparent border-solid border border-gray-300 text-gray-700"
          : "bg-gray-200 text-gray-700"
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default Badge;
